import React from 'react';
import Skeleton from "@mui/material/Skeleton";
import {AssetBoxContainer, AssetBoxWrapper} from "./AssetBoxStyle";


interface AssetBoxSkeletonProps {
}

const AssetBoxSkeleton: React.FC<AssetBoxSkeletonProps> = ({}) => {

    return (

        <AssetBoxContainer
            item
            xs={4}
            md={3}>
            <AssetBoxWrapper>
                <Skeleton variant="rectangular" width="100%" height="100%"/>
            </AssetBoxWrapper>
            <Skeleton variant="text" sx={{mt: 1}}/>
        </AssetBoxContainer>
    );
};

export default AssetBoxSkeleton;
